// src/mocks/handlers/customer/customerResendInviteHandler.ts
import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { genericResponse } from '@/shared/types/api';
import { ICustomerUserBaseRequestBody } from '@/domains/customer/customer.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const customerResendInviteHandler = rest.post<
  ICustomerUserBaseRequestBody,
  genericResponse
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.CUSTOMER_USER_REINVITE}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    return res(
      ctx.status(200),
      ctx.json({ message: 'Invite has been resent successfully' }),
    );
  },
);
